export { default as AssetsTable } from './component';
